<template>
  <div>
    <!-- Popup -->
    <vs-popup :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-full px-8">
            <!-- Title -->
            <div class="vx-row mb-2">
              <vs-input
                class="w-full"
                v-validate="'required|min:3'"
                v-model="form.title"
                label="Title *"
                name="title"
                data-vv-as="Title"
                id="Title"
                placeholder="Ex: Punjabi Song"
              />
              <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
            </div>

            <!-- Company Name -->
            <div class="vx-row mb-2">
              <vs-input
                class="w-full"
                v-validate="'required|min:2'"
                v-model="form.company_name"
                label="Company Name *"
                name="company_name"
                data-vv-as="Company Name"
                id="CompanyName"
                placeholder="Ex: Sangat Records"
              />
              <span class="text-danger text-sm" v-show="errors.has('company_name')">{{ errors.first('company_name') }}</span>
            </div>
          </div>

          <!-- Video Upload -->
          <div class="vx-col w-full px-8 mt-4">
            <label class="vs-input--label block">Video *</label>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="Video"
              ref="files"
              accept=".mp4, .mkv, .mov"
              @change="handleVideoUpload"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              v-validate="videovalidationRule"
              data-vv-as="Video"
            />
            <span class="text-danger text-sm" v-show="errors.has('Video')">{{ errors.first('Video') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="preview_video">
                <video height="150" width="100%" :src="preview_video" controls></video>
              </div>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="create-voice" @click="save_changes">{{ action_name }}</vs-button>
              <vs-button color="danger" class="text-left" @click="isActive = false">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'VoiceBySangatAction',

  props: {
    showModal: Boolean,
    data: Object,
    module_name: String,
    action_name: String
  },

  data() {
    return {
      form: {
        title: '',
        company_name: '',
        video: null
      },
      preview_video: null
    }
  },

  created() {
    if (this.data) {
      this.form.title = this.data.title || ''
      this.form.company_name = this.data.company_name || ''
      this.preview_video = this.data.video || null
    }
  },

  computed: {
    ...mapState('voiceBySangat', ['saveLoading']),
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    },
    videovalidationRule() {
      return !this.data ? 'required' : ''
    }
  },

  methods: {
    ...mapActions('voiceBySangat', {
      create: 'create',
      update: 'update'
    }),

    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fill all mandatory fields correctly',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }

      try {
        const formData = new FormData()
        formData.append('title', this.form.title)
        formData.append('company_name', this.form.company_name)
        if (this.form.video) {
          formData.append('video', this.form.video)
        }

        let result
        if (!this.data) {
          result = await this.create(formData)
        } else {
          result = await this.update({
            id: this.data._id,
            data: formData
          })
        }

        this.$vs.notify({
          title: 'Success',
          text: result.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })

        this.$emit('update-data', true)
        this.isActive = false
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Something went wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    handleVideoUpload(e) {
      const file = e.target.files[0]
      if (!file) return

      if (this.preview_video && !this.data) {
        URL.revokeObjectURL(this.preview_video)
      }
      this.preview_video = URL.createObjectURL(file)
      this.form.video = file
    }
  },

  watch: {
    saveLoading() {
      if (this.saveLoading) {
        this.$vs.loading({
          container: '#create-voice',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-voice > .con-vs-loading')
      }
    }
  }
}
</script>
